export default __webpack_public_path__ + "static/media/eeicons.91aa9b9c.svg";